export default __webpack_public_path__ + "img/Reuss.74e80105.png";